import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=687c3488&scoped=true"
import script from "./FaqItem.vue?vue&type=script&lang=js"
export * from "./FaqItem.vue?vue&type=script&lang=js"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=687c3488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c3488",
  null
  
)

export default component.exports